export const clubBackRouteMixin = {
    computed: {
        backRoute() {
            return this.$route.query.from === 'officer'
                ? '/dashboard/club/management-as-officer'
                : '/dashboard/club/management';
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/clubs/mixins/club-back-route.js